import createReturnMixin from './createReturnMixin'

export default createReturnMixin({
  returnPath: '/notifications',
  clearMutations: ['notifications/clearReturnNotification', 'notifications/resetFilters'],
  showButtonKey: 'showNotificationReturnButton',
  visibilityGetter: (state) => !!state.notifications.returnNotificationId,
  goBackMethodName: 'goBackToNotifications',
})
